import React from 'react';
import { Switch } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

interface SwitchDesktopProps {
    isPro: boolean;
    setIsPro: (value: boolean | ((prev: boolean) => boolean)) => void;
}

const CustomSwitch = styled(Switch)(() => ({
    width: 150,
    height: 50,
    borderRadius: 25,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 10,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(80px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: 'transparent',
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#FF4D00',
            },
        },
        '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: 'transparent',
        },
    },
    '& .MuiSwitch-thumb': {
        width: 50,
        height: 30,
        borderRadius: 30,
        backgroundColor: '#FF4D00',
    },
    '& .MuiSwitch-track': {
        backgroundColor: 'transparent',
    },
}));

const SwitchDesktop: React.FC<SwitchDesktopProps> = ({ isPro, setIsPro }) => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                position: 'absolute',
                top: 132,
                left: 1112,
                width: 501,
                height: 88,
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px #0F4D0029',
                borderRadius: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                padding: '0 30px',
            }}
        >
            {/* Label "Particuliers" */}
            <div
                style={{
                    flex: 1,
                    textAlign: 'left',
                    fontSize: 20,
                    color: isPro ? '#737373' : '#FF4D00',
                    fontWeight: isPro ? 300 : 700,
                    cursor: 'pointer',
                }}
                onClick={() => setIsPro(false)}
            >
                {t('page1:switch_particulars')}
            </div>

            {/* Le Switch lui-même */}
            <div
                style={{
                    width: 150,
                    height: 50,
                    borderRadius: 50,
                    border: '3px solid #707070',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => setIsPro((prev: boolean) => !prev)}
            >
                <CustomSwitch checked={isPro} />
            </div>

            {/* Label "Pros" */}
            <div
                style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: 20,
                    color: isPro ? '#FF4D00' : '#737373',
                    fontWeight: isPro ? 700 : 300,
                    cursor: 'pointer',
                }}
                onClick={() => setIsPro(true)}
            >
                {t('page1:switch_pros')}
            </div>
        </div>
    );
};

export default SwitchDesktop;
